import React from 'react';
import { formatDate } from './formatDate';

/**
 * Date template component
 */
export const DateTemplate: React.FC<{ addDate?: Date | string | null }> = ({ addDate }) => (
  <div>{formatDate(addDate)}</div>
);

export default DateTemplate;
